import { Box, Container, Typography, Paper, Button } from "@mui/material"
import CancelIcon from "@mui/icons-material/Cancel"

const MembershipCancel = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: "center" }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
          <CancelIcon sx={{ fontSize: 80, color: "error.main" }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Payment Cancelled
          </Typography>
          <Typography variant="body1" paragraph>
            Your membership purchase has been cancelled. No payment has been processed.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            If you have any questions or need assistance, please contact our support team.
          </Typography>
          <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
            <Button variant="contained" color="primary" href="/memberships">
              Return to Memberships
            </Button>
            <Button variant="outlined" color="secondary" href="/contact">
              Contact Support
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  )
}

export default MembershipCancel
